import React from 'react';

export function highlightSnippet(snippet, term) {
  if (!snippet || !term) return snippet;
  const idx = snippet.toLowerCase().indexOf(term.toLowerCase());
  if (idx === -1) return snippet;
  return (
    <>
      {snippet.slice(0, idx)}
      <mark style={{ background: '#fef08a', color: 'inherit', borderRadius: 2, padding: '0 1px' }}>{snippet.slice(idx, idx + term.length)}</mark>
      {snippet.slice(idx + term.length)}
    </>
  );
}
